import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';

import Profile from './pages/profile.vue';
import Cases from './pages/cases.vue';


Vue.use(VueRouter);

const routes = [
  { 
    path: '/profile', 
    component: Profile
  },
  {
    path: '/',
    component: Cases
  }
];

const router = new VueRouter ({
  mode: 'history',
  routes
});

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  render: h => h(App),
});
